/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfUserInfoDto } from '../../models/platform-api-result-of-user-info-dto';
import { PlatformDesktopManueelAanmelden } from '../../models/platform-desktop-manueel-aanmelden';

export interface PostUserpresenceActionDesktopmanueelaanmelden$Params {
      body: PlatformDesktopManueelAanmelden
}

export function postUserpresenceActionDesktopmanueelaanmelden(http: HttpClient, rootUrl: string, params: PostUserpresenceActionDesktopmanueelaanmelden$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserInfoDto>> {
  const rb = new RequestBuilder(rootUrl, postUserpresenceActionDesktopmanueelaanmelden.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfUserInfoDto>;
    })
  );
}

postUserpresenceActionDesktopmanueelaanmelden.PATH = '/api/userpresence/action/desktopmanueelaanmelden';
